import { Serializable, SaleOrder } from "@tendercuts/models";

export class OrderHistoryPagination
  implements Serializable<OrderHistoryPagination> {
  // Next page url from api
  public next: string = "";
  // Prev page url from api
  public previous: string = "";
  // cash orders count in the selected page
  public cashOrdersCount: number = 0;
  // card orders count in the selected page
  public cardOrdersCount: number = 0;
  // vendor order count in the selected page
  public vendorOrdersCount: number = 0;
  // total order count in pos
  public count: number;
  public orders: SaleOrder[] = [];
  public results: any = [];

  constructor() {}

  deserialize(input) {
    if (!input) {
      return this;
    }

    this.count = input.count;
    this.next = input.next;
    this.previous = input.previous;
    this.results = input.results;

    if (this.results && this.results.length) {
      for (let order of this.results) {
        const saleOrder = new SaleOrder().deserialize(order);
        this.orders.push(saleOrder);
      }

      this.cashOrdersCount = this.orders.filter(
        (order) => order.isPosCashPayment
      ).length;
      this.cardOrdersCount = this.orders.filter(
        (order) => order.isPosCardPayment
      ).length;
      this.vendorOrdersCount = this.orders.filter(
        (order) => order.isPosVendorPayment
      ).length;
    }

    return this;
  }
}
